var React = require('react');

function Favorite (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.5 1L21.2895 10.5447L32 12.0846L24.25 19.51L26.079 30L16.5 25.0447L6.921 30L8.75 19.51L1 12.0846L11.7105 10.5447L16.5 1Z","stroke":"#D1D1D1","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Favorite.defaultProps = {"width":"33","height":"31","viewBox":"0 0 33 31","fill":"none"};

module.exports = Favorite;

Favorite.default = Favorite;
